import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { fmtDate, fmtNum } from "../lib/format";
import { useCompany } from "../context/CompanyContext";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../components/ui/select";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../components/ui/table";
import { downloadDoc } from "../components/documents/DocumentsPanel";
import { FolderOpen, Download, ExternalLink } from "lucide-react";

export default function Documents() {
  const nav = useNavigate();
  const { company } = useCompany();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("tutte");
  useEffect(() => { api.get("/documents/all").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const cats = useMemo(() => [...new Set(rows.map((r) => r.categoria))].sort(), [rows]);
  const filtered = rows.filter((r) => (cat === "tutte" || r.categoria === cat) && (!q || JSON.stringify(r).toLowerCase().includes(q.toLowerCase())));
  return (
    <div className="space-y-5" data-testid="page-documents">
      <div><h1 className="text-3xl font-display font-bold text-primary flex items-center gap-2"><FolderOpen className="w-7 h-7" /> Archivio documenti {company ? `— ${company.denominazione}` : ""}</h1><p className="text-sm text-muted-foreground">{rows.length} documenti su operazioni e appartamenti</p></div>
      <Card className="p-4 flex flex-wrap gap-3">
        <Input placeholder="Cerca..." value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" data-testid="docs-search" />
        <Select value={cat} onValueChange={setCat}><SelectTrigger className="w-48"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="tutte">Tutte le categorie</SelectItem>{cats.map((c) => <SelectItem key={c} value={c} className="capitalize">{c}</SelectItem>)}</SelectContent></Select>
      </Card>
      <Card className="p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow className="bg-muted/50"><TableHead>Data</TableHead><TableHead>File</TableHead><TableHead>Categoria</TableHead><TableHead>Riferimento</TableHead><TableHead>Checklist</TableHead><TableHead>Dim.</TableHead><TableHead>Associati</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {filtered.length === 0 && <TableRow><TableCell colSpan={8} className="text-center py-8 text-muted-foreground">Nessun documento</TableCell></TableRow>}
            {filtered.map((d) => (
              <TableRow key={d.id} data-testid="docs-row">
                <TableCell>{fmtDate(d._created)}</TableCell><TableCell className="font-medium">{d.nome_file}</TableCell><TableCell className="capitalize">{d.categoria}</TableCell>
                <TableCell><button className="underline text-left flex items-center gap-1" onClick={() => nav(d.link)}>{d.riferimento}<ExternalLink className="w-3 h-3" /></button></TableCell>
                <TableCell className="text-xs">{d.checklist_key || "—"}</TableCell><TableCell className="text-xs">{fmtNum(Math.round(d.size / 1024))} KB</TableCell>
                <TableCell>{d.visibile_investitori ? <Badge className="bg-emerald-600">visibile</Badge> : <span className="text-xs text-muted-foreground">—</span>}</TableCell>
                <TableCell><Button variant="ghost" size="icon" onClick={() => downloadDoc(d)}><Download className="w-4 h-4" /></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
